import axios from 'axios'
import {GetTypeModuleDto, MasterFiltersDto, MasterModel} from '../models'
import {ResponseObjectPaginated} from '../../../../../models'
const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getMasterModuleService(dto: GetTypeModuleDto, filters: MasterFiltersDto = {}) {
  return axios.post<ResponseObjectPaginated<MasterModel[]>>(`${BASEURL}/master/getAll`, filters, {
    params: dto,
  })
}
